import React from 'react';
import { LandingLayout } from 'components/Landing/LandingLayout';
import { observer } from 'mobx-react';
import { withErrorBoundary } from 'react-error-boundary';
import { handleError } from 'services/ErrorService';
import ComponentError from 'components/Error/ComponentError';
import { useTranslation } from 'react-i18next';

interface ObjectivesProps {
  objectives?: string[];
}

const Objectives: React.FC<ObjectivesProps> = ({ objectives }) => {
  const { t } = useTranslation();

  if (!objectives || !objectives.length) {
    return null;
  }

  return (
    <>
      <LandingLayout.ContentHeading>
        {t('Objectives')}
      </LandingLayout.ContentHeading>
      <LandingLayout.List>
        {objectives.map?.((objective) => (
          <li key={objective}>{objective}</li>
        ))}
      </LandingLayout.List>
    </>
  );
};

export default withErrorBoundary(
  observer(Objectives),
  ComponentError,
  handleError,
);
